import { Icon } from './types';

export const DoctorIcon: Icon = (props) => (
  <svg
    viewBox={'0 0 24 24'}
    id={'doctor'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      d={
        'M24 9.069c0-1.657-1.343-2.958-3-2.958s-3 1.343-3 2.958c0 1.396.958 2.56 2.25 2.894v4.606c0 3.309-2.692 5.958-6 5.958s-6-2.691-6-5.958v-.076c3.78-.382 6.75-3.546 6.75-7.425V2.36a.75.75 0 0 0-.415-.67l-3-1.458a.75.75 0 0 0-1.006.335c-.187.288-.037.737.333.923L13.5 2.782v6.286c0 3.309-2.692 5.958-6 5.958s-6-2.648-6-5.957V2.782L4.086 1.49A.75.75 0 1 0 3.412.148l-3 1.458C.16 1.776 0 2.035 0 2.32v6.708c0 3.879 2.97 7.04 6.75 7.425v.076c0 4.135 3.365 7.458 7.5 7.458s7.5-3.365 7.5-7.458v-4.567A2.987 2.987 0 0 0 24 9.07Zm-3 1.5c-.828 0-1.5-.672-1.5-1.458 0-.828.672-1.458 1.5-1.458s1.5.672 1.5 1.458c0 .788-.67 1.458-1.5 1.458Z'
      }
    />
  </svg>
);
